import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'replace'})
export class ChangePipe implements PipeTransform {
  transform(value: string): string {
    if(!!value){
      let newValue = value.replace(/</g, "&lt;").replace(/>/g, "&gt;");
      return `${newValue}`;
    }
  }
}
